import React, { forwardRef } from "react";

import { StyledMedia } from "./Styles";
import {
  PortableTextMediaBlock,
  PortableTextMediaImageVariant,
} from "../PortableText/types";
import { Caption1 } from "../Typography";

export interface IMediaProps
  extends Omit<PortableTextMediaBlock, "type" | "variant">,
    React.ComponentPropsWithoutRef<"div"> {
  variant?: PortableTextMediaImageVariant;
}

/**
 * An image block: a screenshot renders framed (border, no shadow), a flat
 * illustration renders without a frame. The caption sits below the frame.
 */
export const Media = forwardRef<HTMLDivElement, IMediaProps>(
  ({ src, alt, variant = "illustration", caption, ...rest }, ref) => (
    <StyledMedia ref={ref} $bordered={variant === "screenshot"} {...rest}>
      <div className="c-media-frame">
        <img src={src} alt={alt ?? ""} />
      </div>
      {caption ? <Caption1 color="secondary">{caption}</Caption1> : null}
    </StyledMedia>
  )
);

Media.displayName = "Media";
